<sgt-select
  [options]="selectorOptionsPeriodicidadeCompras"
  [settings]="selectorSettings"
  (selectedValueChanged)="onChangePeriodicidadeCompra($event)"
>
</sgt-select>

<ng-container *ngIf="isToShowTabelaVigenciaCarteiraCliente">
  <div class="tabela-wrapper">
    <div class="indicador-seta"></div>

    <div class="tabela-vigenci-carteira-cliente">
      <sgt-tabela-vigencia-carteira-cliente
        [idPeriodicidadeCompraInFocus]="pendingSelectionId"
      ></sgt-tabela-vigencia-carteira-cliente>
    </div>
  </div>
</ng-container>
